import React, { useState, useEffect, useRef } from "react";
import arrowDown from "../assets/icons/arrow_down_option.svg";
import "../styles/customDropDown.css";

const CustomDropdown = ({
  label,
  options,
  value,
  onChange,
  classNameInput,
}) => {
  const [open, setOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const dropdownRef = useRef(null);
  const listRef = useRef(null);

  const handleSelect = (option) => {
    onChange(option?.value);
    setOpen(false);
    dropdownRef.current.querySelector(".dropdown-selected").focus();
  };

  const toggleDropdown = () => setOpen(!open);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpen(false);
      setFocusedIndex(-1);
    }
  };

  const handleListKeyDown = (event) => {
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        setFocusedIndex((prevIndex) =>
          prevIndex < options.length - 1 ? prevIndex + 1 : 0
        );
        break;
      case "ArrowUp":
        event.preventDefault();
        setFocusedIndex((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : options.length - 1
        );
        break;
      case "Enter":
      case " ":
        event.preventDefault();
        if (focusedIndex !== -1) {
          handleSelect(options[focusedIndex]);
        }
        break;
      case "Escape":
        setOpen(false);
        dropdownRef.current.querySelector(".dropdown-selected").focus();
        break;
      case "Tab":
        setOpen(false);
        break;
      default:
        break;
    }
  };

  const handleButtonKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleDropdown();
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (open && listRef.current) {
      setFocusedIndex(-1);
      listRef.current.focus();
    }
  }, [open]);
  const selectedOption = options.find((option) => option?.value === value);
  const stringLabel = selectedOption?.label || value;

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <label className="dropdown-label">{label}</label>
      <div
        className={`dropdown-selected ${open ? "open" : ""} ${classNameInput}`}
        onClick={toggleDropdown}
        onKeyDown={handleButtonKeyDown}
        tabIndex={0}
        role="button"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {value && (
          <span className={`${value ? "selected" : ""}`}>{stringLabel}</span>
        )}
        <img
          src={arrowDown}
          alt="arrow"
          className={`arrow-icon ${open ? "rotate" : ""}`}
        />
      </div>
      {open && (
        <ul
          className="dropdown-list"
          ref={listRef}
          role="listbox"
          tabIndex={0}
          onKeyDown={handleListKeyDown}
          aria-activedescendant={
            focusedIndex !== -1
              ? `option-${options[focusedIndex].value}`
              : undefined
          }
        >
          {options?.map((opt, index) => (
            <li
              key={opt.value}
              id={`option-${opt.value}`}
              className={`dropdown-option ${
                index === focusedIndex ? "focused" : ""
              }`}
              onClick={() => handleSelect(opt)}
              role="option"
              aria-selected={value === opt?.value}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
